// ////  NOTE: Run `npm run graphiql` to enable. The script will automatically
// ////        remove all the commented out code below.

// ////        Access @ https://localhost:3000/graphiql/graphiql

import React from 'react';
import ReactDOM from 'react-dom';
// import GraphiQL from 'graphiql';
// import { createGraphiQLFetcher } from '@graphiql/toolkit';
// import cookie from 'cookie';
import styled from 'styled-components';
// import 'graphiql/graphiql.css';

// const fetcher = createGraphiQLFetcher({
//   url: `${window.location.origin}/graphql`,
//   headers: {
//     'X-XSRF-TOKEN': cookie.parse(document.cookie)['XSRF-TOKEN'] || ''
//   }
// });

export const GraphiQLClient = () =>
  ReactDOM.createPortal(
    <StyledGraphiQL>
      {/* <GraphiQL fetcher={fetcher} editorTheme="dracula" /> */}
      <StyledCenter>
        install with:&nbsp;<b>npm run graphiql</b>
      </StyledCenter>
    </StyledGraphiQL>,
    document.querySelector('#root') as HTMLElement
  );

const StyledGraphiQL = styled.div`
  position: absolute;
  top: 0;
  height: 100%;
  width: 100%;
  z-index: 999;
`;

const StyledCenter = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100vh;
`;
